<template>
    <div class="marquee-container">
      <div class="marquee">
        <div class="marquee-content">
          <span v-for="(text, index) in marqueeTexts" :key="index" class="marquee-text">
            {{ text }}
          </span>
          <!-- Duplicate text content for seamless effect -->
          <span v-for="(text, index) in marqueeTexts" :key="index + 'dup'" class="marquee-text">
            {{ text }}
          </span>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        marqueeTexts: [
          "April 8 Live Game - ",
          "Welcome to April 8 Live Game - ",
          "Enjoy! - ",
          "Get Ready for Action - ",
          "Are You Ready? - "
        ]
      };
    }
  };
  </script>
  
  <style scoped>
  .marquee-container {
    overflow: hidden;
    width: 100%;
    height: 60px; /* Adjust the height */
    background-color: #1d417a; /* Dark background */
    display: flex;
    align-items: center;
  }
  
  .marquee {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }
  
  .marquee-content {
    display: flex;
    animation: scroll 20s linear infinite;
  }
  
  .marquee-text {
    color: white;
    font-size: 1.8rem;
    font-weight: bold;
    margin-right: 100px;
    text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.8); /* Glowing effect */
    animation: colorChange 5s infinite alternate;
  }
  
  /* Keyframe animation to scroll text continuously */
  @keyframes scroll {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-50%);
    }
  }
  
  /* Keyframe for color-changing effect */
  @keyframes colorChange {
    0% {
      color: #4CAF50;
    }
    50% {
      color: #fdb927;
    }
    100% {
      color: white;
    }
  }
  </style>
  